type StatusCodes = '403' | '404' | '500';

export const HTTP_STATUS_CODES: Record<StatusCodes, number> = {
  '403': 403,
  '404': 404,
  '500': 500,
};
